import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const isActiveRoute = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">
            <img
              src="https://cdn.shopify.com/s/files/1/0019/2020/4854/files/proper-wild-logo.svg?25097"
              alt="Proper Wild"
              className="logo-image"
            />
          </Link>
        </div>

        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-links">
            <li>
              <Link
                to="/competition"
                className={isActiveRoute('/competition') ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                Competition Info
              </Link>
            </li>
            <li>
              <Link
                to="/talking-points"
                className={isActiveRoute('/talking-points') ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                Talking Points
              </Link>
            </li>
            <li>
              <Link
                to="/faqs"
                className={isActiveRoute('/faqs') ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                FAQs
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
